import script from "./StockBasicFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./StockBasicFilter.vue?vue&type=script&setup=true&lang=js"

import "./StockBasicFilter.vue?vue&type=style&index=0&id=8228526a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8228526a"]])

export default __exports__